module.exports = __webpack_public_path__ + "static/img/program_02.707bc70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/program_02.jpg
// module id = 7kKz
// module chunks = 0